module.exports = __webpack_public_path__ + "img/55.cc4cf238.jpg";